import React from 'react'
import { MenuItem } from '@szhsin/react-menu'
import { Virtuoso } from 'react-virtuoso'
import type { CustomMetadataResponse } from '../../../interfaces'

interface VirtualizedCustomMetadataListProps {
  items: CustomMetadataResponse[]
  onItemClick: (field: CustomMetadataResponse) => void
}

const VirtualizedCustomMetadataList = ({
  items,
  onItemClick,
}: VirtualizedCustomMetadataListProps): React.ReactElement | null => {
  if (items.length === 0) {
    return null
  }

  return (
    <Virtuoso
      data={items}
      totalCount={items.length}
      itemContent={(index, item) => (
        <MenuItem
          key={item.name}
          onClick={() => void onItemClick(item)}
          style={{
            paddingTop: '0.4rem',
            paddingBottom: '0.4rem',
            paddingLeft: '0.8rem',
            paddingRight: '0.8rem',
            minWidth: 0,
            width: '100%',
          }}
        >
          <span
            style={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {item.label}
          </span>
        </MenuItem>
      )}
      style={{
        height: '100%',
      }}
    />
  )
}

export default VirtualizedCustomMetadataList
